import React from 'react';

import { Form as FormComponent } from 'react-bootstrap';

import '@consumer-bootstrap/components/form.scss';

export type FormPropsT = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  noValidate?: boolean;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
};
export type FormT = React.FC<FormPropsT>;

export const Form: FormT = ({ children, ...props }) => {
  return <FormComponent {...props}>{children}</FormComponent>;
};
